/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthUser,
  BodyToggleCallAvailability,
  CreatePracticeUserParams,
  DeactivateRestoreUserParams,
  GetUsersParams,
  HTTPValidationError,
  InviteUser200,
  MfaSync,
  PageUserManyRead,
  RevokeOtherSessionsParams,
  SelfProfileUpdate,
  User,
  UserCreate,
  UserRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new user.

This will create the user in our database and in Firebase Auth.
 * @summary Create User
 */
export const createUser = (userCreate: UserCreate, signal?: AbortSignal) => {
  return customInstance<User>({
    url: `/api/user/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: userCreate,
    signal,
  });
};

export const getCreateUserMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: UserCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: UserCreate },
  TContext
> => {
  const mutationKey = ["createUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { data: UserCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUser>>
>;
export type CreateUserMutationBody = UserCreate;
export type CreateUserMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create User
 */
export const useCreateUser = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUser>>,
      TError,
      { data: UserCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: UserCreate },
  TContext
> => {
  const mutationOptions = getCreateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get all users (excluding patients).
 * @summary Get Users
 */
export const getUsers = (params?: GetUsersParams, signal?: AbortSignal) => {
  return customInstance<PageUserManyRead>({
    url: `/api/user/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUsersQueryKey = (params?: GetUsersParams) => {
  return ["api", "user", ...(params ? [params] : [])] as const;
};

export const getGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
    signal,
  }) => getUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError = ErrorType<void | HTTPValidationError>;

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Users
 */

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to create a new practice user. This is a non-admin route for practice staff to create
their own users.

This will create the user in our database and in Firebase Auth, add them to the practice entity,
and give them the PATIENT_360 permission.
 * @summary Create Practice User
 */
export const createPracticeUser = (
  userCreate: UserCreate,
  params: CreatePracticeUserParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/user/create_practice_user`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: userCreate,
    params,
    signal,
  });
};

export const getCreatePracticeUserMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPracticeUser>>,
    TError,
    { data: UserCreate; params: CreatePracticeUserParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPracticeUser>>,
  TError,
  { data: UserCreate; params: CreatePracticeUserParams },
  TContext
> => {
  const mutationKey = ["createPracticeUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPracticeUser>>,
    { data: UserCreate; params: CreatePracticeUserParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return createPracticeUser(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePracticeUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPracticeUser>>
>;
export type CreatePracticeUserMutationBody = UserCreate;
export type CreatePracticeUserMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Practice User
 */
export const useCreatePracticeUser = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPracticeUser>>,
      TError,
      { data: UserCreate; params: CreatePracticeUserParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPracticeUser>>,
  TError,
  { data: UserCreate; params: CreatePracticeUserParams },
  TContext
> => {
  const mutationOptions = getCreatePracticeUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get the current user and their permissions.
 * @summary Get Auth User
 */
export const getAuthUser = (signal?: AbortSignal) => {
  return customInstance<AuthUser>({
    url: `/api/user/me`,
    method: "GET",
    signal,
  });
};

export const getGetAuthUserQueryKey = () => {
  return ["api", "user", "me"] as const;
};

export const getGetAuthUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUser>>> = ({
    signal,
  }) => getAuthUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthUser>>
>;
export type GetAuthUserQueryError = ErrorType<void>;

export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Auth User
 */

export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuthUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Toggle the current user's call availability (Do Not Disturb).
 * @summary Toggle Call Availability
 */
export const toggleCallAvailability = (
  bodyToggleCallAvailability: BodyToggleCallAvailability,
) => {
  return customInstance<boolean>({
    url: `/api/user/me/call-availability`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: bodyToggleCallAvailability,
  });
};

export const getToggleCallAvailabilityMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleCallAvailability>>,
    TError,
    { data: BodyToggleCallAvailability },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleCallAvailability>>,
  TError,
  { data: BodyToggleCallAvailability },
  TContext
> => {
  const mutationKey = ["toggleCallAvailability"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleCallAvailability>>,
    { data: BodyToggleCallAvailability }
  > = (props) => {
    const { data } = props ?? {};

    return toggleCallAvailability(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleCallAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleCallAvailability>>
>;
export type ToggleCallAvailabilityMutationBody = BodyToggleCallAvailability;
export type ToggleCallAvailabilityMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Toggle Call Availability
 */
export const useToggleCallAvailability = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleCallAvailability>>,
      TError,
      { data: BodyToggleCallAvailability },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleCallAvailability>>,
  TError,
  { data: BodyToggleCallAvailability },
  TContext
> => {
  const mutationOptions = getToggleCallAvailabilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update the current user's first/last name (also synced to Firebase display name).
 * @summary Update Self Profile
 */
export const updateSelfProfile = (selfProfileUpdate: SelfProfileUpdate) => {
  return customInstance<User>({
    url: `/api/user/me/profile`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: selfProfileUpdate,
  });
};

export const getUpdateSelfProfileMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSelfProfile>>,
    TError,
    { data: SelfProfileUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSelfProfile>>,
  TError,
  { data: SelfProfileUpdate },
  TContext
> => {
  const mutationKey = ["updateSelfProfile"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSelfProfile>>,
    { data: SelfProfileUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateSelfProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSelfProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSelfProfile>>
>;
export type UpdateSelfProfileMutationBody = SelfProfileUpdate;
export type UpdateSelfProfileMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Self Profile
 */
export const useUpdateSelfProfile = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSelfProfile>>,
      TError,
      { data: SelfProfileUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSelfProfile>>,
  TError,
  { data: SelfProfileUpdate },
  TContext
> => {
  const mutationOptions = getUpdateSelfProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revoke all Firebase refresh tokens for the current user.

The frontend calls this immediately after a successful Firebase
`updatePassword`, then force-refreshes its own ID token so this tab
keeps working. Other sessions lose access when they next try to
refresh.

When `password_changed=True`, the user is also emailed a
"your password was changed" notice so they have an audit trail and
a path back to support if the change wasn't them.
 * @summary Revoke Other Sessions
 */
export const revokeOtherSessions = (
  params?: RevokeOtherSessionsParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/user/me/revoke-other-sessions`,
    method: "POST",
    params,
    signal,
  });
};

export const getRevokeOtherSessionsMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeOtherSessions>>,
    TError,
    { params?: RevokeOtherSessionsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeOtherSessions>>,
  TError,
  { params?: RevokeOtherSessionsParams },
  TContext
> => {
  const mutationKey = ["revokeOtherSessions"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeOtherSessions>>,
    { params?: RevokeOtherSessionsParams }
  > = (props) => {
    const { params } = props ?? {};

    return revokeOtherSessions(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeOtherSessionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeOtherSessions>>
>;

export type RevokeOtherSessionsMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Revoke Other Sessions
 */
export const useRevokeOtherSessions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeOtherSessions>>,
      TError,
      { params?: RevokeOtherSessionsParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revokeOtherSessions>>,
  TError,
  { params?: RevokeOtherSessionsParams },
  TContext
> => {
  const mutationOptions = getRevokeOtherSessionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sync MFA enrollment state to the DB after a Firebase enroll/unenroll.

Firebase remains the source of truth; this just keeps the denormalized mirror
in the `users` table in sync.
 * @summary Sync Self Mfa Enabled
 */
export const syncSelfMfaEnabled = (signal?: AbortSignal) => {
  return customInstance<MfaSync>({
    url: `/api/user/me/mfa-sync`,
    method: "POST",
    signal,
  });
};

export const getSyncSelfMfaEnabledMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncSelfMfaEnabled>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncSelfMfaEnabled>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncSelfMfaEnabled"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncSelfMfaEnabled>>,
    void
  > = () => {
    return syncSelfMfaEnabled();
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncSelfMfaEnabledMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncSelfMfaEnabled>>
>;

export type SyncSelfMfaEnabledMutationError = ErrorType<void>;

/**
 * @summary Sync Self Mfa Enabled
 */
export const useSyncSelfMfaEnabled = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof syncSelfMfaEnabled>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof syncSelfMfaEnabled>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSyncSelfMfaEnabledMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Email the current user a Firebase email-verification link.

Firebase blocks MFA enrollment for unverified emails, and email/password
accounts are created unverified, so this gives users a self-service way to
clear that block.
 * @summary Send Self Email Verification
 */
export const sendSelfEmailVerification = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/user/me/send-email-verification`,
    method: "POST",
    signal,
  });
};

export const getSendSelfEmailVerificationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSelfEmailVerification>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendSelfEmailVerification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["sendSelfEmailVerification"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendSelfEmailVerification>>,
    void
  > = () => {
    return sendSelfEmailVerification();
  };

  return { mutationFn, ...mutationOptions };
};

export type SendSelfEmailVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendSelfEmailVerification>>
>;

export type SendSelfEmailVerificationMutationError = ErrorType<void>;

/**
 * @summary Send Self Email Verification
 */
export const useSendSelfEmailVerification = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendSelfEmailVerification>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendSelfEmailVerification>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSendSelfEmailVerificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to deactivate or restore a user by their user_id.
 * @summary Deactivate Restore User
 */
export const deactivateRestoreUser = (
  userId: string,
  params: DeactivateRestoreUserParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/user/deactivate_restore_user/${userId}`,
    method: "POST",
    params,
    signal,
  });
};

export const getDeactivateRestoreUserMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateRestoreUser>>,
    TError,
    { userId: string; params: DeactivateRestoreUserParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateRestoreUser>>,
  TError,
  { userId: string; params: DeactivateRestoreUserParams },
  TContext
> => {
  const mutationKey = ["deactivateRestoreUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateRestoreUser>>,
    { userId: string; params: DeactivateRestoreUserParams }
  > = (props) => {
    const { userId, params } = props ?? {};

    return deactivateRestoreUser(userId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateRestoreUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateRestoreUser>>
>;

export type DeactivateRestoreUserMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Deactivate Restore User
 */
export const useDeactivateRestoreUser = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateRestoreUser>>,
      TError,
      { userId: string; params: DeactivateRestoreUserParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateRestoreUser>>,
  TError,
  { userId: string; params: DeactivateRestoreUserParams },
  TContext
> => {
  const mutationOptions = getDeactivateRestoreUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get a user by their user_id.
 * @summary Get User
 */
export const getUser = (userId: string, signal?: AbortSignal) => {
  return customInstance<UserRead>({
    url: `/api/user/${userId}`,
    method: "GET",
    signal,
  });
};

export const getGetUserQueryKey = (userId?: string) => {
  return ["api", "user", userId] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({
    signal,
  }) => getUser(userId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = ErrorType<void | HTTPValidationError>;

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User
 */

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update a user.

This will update the user in our database and in Firebase Auth.
 * @summary Update User
 */
export const updateUser = (userId: string, userCreate: UserCreate) => {
  return customInstance<User>({
    url: `/api/user/${userId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: userCreate,
  });
};

export const getUpdateUserMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { userId: string; data: UserCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { userId: string; data: UserCreate },
  TContext
> => {
  const mutationKey = ["updateUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    { userId: string; data: UserCreate }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUser>>
>;
export type UpdateUserMutationBody = UserCreate;
export type UpdateUserMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update User
 */
export const useUpdateUser = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUser>>,
      TError,
      { userId: string; data: UserCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { userId: string; data: UserCreate },
  TContext
> => {
  const mutationOptions = getUpdateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to invite a user whose account has already been created in Firebase.

It generates a password reset link that they can then use to set their password.
 * @summary Invite User
 */
export const inviteUser = (email: string, signal?: AbortSignal) => {
  return customInstance<InviteUser200>({
    url: `/api/user/${email}/invite/`,
    method: "POST",
    signal,
  });
};

export const getInviteUserMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteUser>>,
    TError,
    { email: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  { email: string },
  TContext
> => {
  const mutationKey = ["inviteUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteUser>>,
    { email: string }
  > = (props) => {
    const { email } = props ?? {};

    return inviteUser(email);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteUser>>
>;

export type InviteUserMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Invite User
 */
export const useInviteUser = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inviteUser>>,
      TError,
      { email: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  { email: string },
  TContext
> => {
  const mutationOptions = getInviteUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to send an invite email to a user.
 * @summary Send Invite Email
 */
export const sendInviteEmail = (userEmail: string, signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/user/${userEmail}/send_invite_email`,
    method: "POST",
    signal,
  });
};

export const getSendInviteEmailMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInviteEmail>>,
    TError,
    { userEmail: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendInviteEmail>>,
  TError,
  { userEmail: string },
  TContext
> => {
  const mutationKey = ["sendInviteEmail"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendInviteEmail>>,
    { userEmail: string }
  > = (props) => {
    const { userEmail } = props ?? {};

    return sendInviteEmail(userEmail);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendInviteEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendInviteEmail>>
>;

export type SendInviteEmailMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Send Invite Email
 */
export const useSendInviteEmail = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendInviteEmail>>,
      TError,
      { userEmail: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendInviteEmail>>,
  TError,
  { userEmail: string },
  TContext
> => {
  const mutationOptions = getSendInviteEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to set a user's FCM registration token in the database.
 * @summary Set Fcm Registration Token
 */
export const setFcmRegistrationToken = (
  setFcmRegistrationTokenBody: string,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/user/fcm_registration_token`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setFcmRegistrationTokenBody,
    signal,
  });
};

export const getSetFcmRegistrationTokenMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setFcmRegistrationToken>>,
    TError,
    { data: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setFcmRegistrationToken>>,
  TError,
  { data: string },
  TContext
> => {
  const mutationKey = ["setFcmRegistrationToken"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setFcmRegistrationToken>>,
    { data: string }
  > = (props) => {
    const { data } = props ?? {};

    return setFcmRegistrationToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetFcmRegistrationTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof setFcmRegistrationToken>>
>;
export type SetFcmRegistrationTokenMutationBody = string;
export type SetFcmRegistrationTokenMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Set Fcm Registration Token
 */
export const useSetFcmRegistrationToken = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setFcmRegistrationToken>>,
      TError,
      { data: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setFcmRegistrationToken>>,
  TError,
  { data: string },
  TContext
> => {
  const mutationOptions = getSetFcmRegistrationTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
